export const inventoryMappers = {
  mapInventoryRecord(data) {
    const mappedData = {
      ...data,
      quantity: Number(data.quantity),
      computedQuantity: Number(data.computedQuantity),
      useAddedValue: false,
      v1: null,
      v2: null,
      v3: null,
      v4: null
    };
    return mappedData;
  }
};
